import { Info } from "@mui/icons-material";
import { Typography } from "@mui/material";

const DocumentUploadHeader = ({ maxDocSize, fileReq }) => {
  return (
    <>
      <div className="w-full items-center" data-testid="container-title">
        <Typography className="w-full text-center text-[1.5rem] font-bold text-black">
          Upload Document To Case
        </Typography>
      </div>

      <div data-testid="container-subTitle">
        <p className="text-center text-[12px] text-slate-500">
          <Info className="text-[12px]" />
          &nbsp; {maxDocSize} &nbsp;|&nbsp; Supported File Extensions -{" "}
          {!fileReq ? "Select a Document Type to View" : fileReq}
        </p>
      </div>
    </>
  );
};

export default DocumentUploadHeader;
